import React, { useContext } from "react";
import "./Popular.css";
import Item from "../Items/Item";
import { ShopContext } from "../../Context/ShopContext";
import default_img from "../../Components/Assets/default_img.png";
import PageLoader from "../Assets/PageLoader/PageLoader";


const mainURL = process.env.REACT_APP_API_BASE_URL;

const Popular = () => {
  const { popular_products, loading } = useContext(ShopContext);

  if (loading) {
    return <PageLoader text="Loading popular products" />;
  }

  return (
    <div className="popular">
      <h1>POPULAR PRODUCTS</h1>
      <hr />

      <div className="popular-item">
        {popular_products.length === 0 ? (
          <p className="no-product">No Product Found</p>
        ) : (
          popular_products.map((item) => {
            const imagePath =
              item?.product_images?.[0]?.image_path
                ? `${mainURL}/${item.product_images[0].image_path}`
                : default_img;

            const sellingPrice =
              item?.product_cost?.[0]?.selling_price ?? 0;

            return (
              <Item
                key={item.item_id}
                id={item.item_id}
                name={item.item_name}
                image={imagePath}
                is_wishlist={item.is_wishlist}
                new_price={sellingPrice}
                old_price={sellingPrice}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default Popular;
